var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("h3", { staticClass: "headline mb-0 admin-header" }, [
                    _vm._v("Integration Tokens"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", icon: "", color: "grey lighten-1" },
                      on: {
                        click: function ($event) {
                          return _vm.refresh(_vm.pagination)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("fas fa-sync")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              items: _vm.integrationTokens,
                              loading: _vm.loading,
                              headers: _vm.headers,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.name",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: { to: "" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.editItem(item)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "item.updatedDate",
                                fn: function ({ item }) {
                                  return [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDateTime(item.updatedDate)
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.deleted",
                                fn: function ({ item }) {
                                  return [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(item.deleted ? "yes" : "no")
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticStyle: {
                                              height: "0px",
                                              width: "0px",
                                              "padding-right": "2px",
                                            },
                                            attrs: { text: "", icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editItem(item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "font-size": "18px",
                                                },
                                                attrs: {
                                                  color: "grey lighten-1",
                                                },
                                              },
                                              [_vm._v("fas fa-pencil")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-spacer"),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            staticStyle: {
                                              height: "0px",
                                              width: "0px",
                                              "padding-right": "2px",
                                            },
                                            attrs: { text: "", icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteItem(item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "font-size": "18px",
                                                },
                                                attrs: {
                                                  color: "grey lighten-1",
                                                },
                                              },
                                              [_vm._v("fas fa-trash")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-actions", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function ($event) {
                        return _vm.newItem()
                      },
                    },
                  },
                  [_vm._v("New Token")]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px" },
              model: {
                value: _vm.showEditDialog,
                callback: function ($$v) {
                  _vm.showEditDialog = $$v
                },
                expression: "showEditDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v("Integration Token"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                          model: {
                            value: _vm.validItem,
                            callback: function ($$v) {
                              _vm.validItem = $$v
                            },
                            expression: "validItem",
                          },
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "subheading",
                                      attrs: { xs12: "" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                               Id: " +
                                          _vm._s(_vm.editedItem.id) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "", "ml-4": "" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          items: _vm.organizations,
                                          label: "Organization",
                                          "item-text": "text",
                                          "item-value": "value",
                                        },
                                        model: {
                                          value: _vm.editedItem.org.id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem.org,
                                              "id",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.org.id",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: [_vm.rules.required],
                                          label: "Key",
                                        },
                                        model: {
                                          value: _vm.editedItem.key,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.editedItem, "key", $$v)
                                          },
                                          expression: "editedItem.key",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: [_vm.rules.required],
                                          label: "Token",
                                        },
                                        model: {
                                          value: _vm.editedItem.token,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "token",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.token",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: { label: "System Id" },
                                        model: {
                                          value: _vm.editedItem.system.id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem.system,
                                              "id",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.system.id",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c("v-checkbox", {
                                        attrs: { label: "Deleted" },
                                        model: {
                                          value: _vm.editedItem.deleted,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "deleted",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.deleted",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-4",
                          attrs: {
                            color: "primary",
                            outlined: "",
                            rounded: "",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.close.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(_vm._s("Cancel"))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            rounded: "",
                            disabled: !_vm.validItem,
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.save.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }